/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryShowSubCategoryResponse } from './CategoryShowSubCategoryResponse';

export type CategoryShowSubCategoryResponseApiRespoonse = {
    data?: CategoryShowSubCategoryResponse;
    status?: CategoryShowSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryShowSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

